import { fastTrackStatus } from '@helpers';

import clamp from 'lodash/clamp';

/**
 * gets FastTrack status message to display
 * @param  {Object}  options.data
 * @param  {Boolean} options.showTruncatedMessage
 * @return {String}
 */
export const getFastTrackStatusMessage = ({ data, showTruncatedMessage }) => {
  const processingStatuses = [fastTrackStatus.RUNNING, fastTrackStatus.CLEANUP];
  const topicCount = data?.numberCompleteTopics + data?.numberIncompleteTopics;

  let message;

  switch (true) {
    case data?.status === fastTrackStatus.QUEUED:
      message = 'In Queue';
      break;
    case data?.status === fastTrackStatus.SETUP:
      message = 'Setup';
      break;
    case processingStatuses.includes(data?.status):
      message =
        (showTruncatedMessage ? '' : 'Processing ') +
        `(${clamp(data?.numberCompleteTopics + 1, 1, topicCount)}/${topicCount})`;
      break;
    case data?.status === fastTrackStatus.COMPLETED:
      return 'Complete';
    case data?.status === fastTrackStatus.EXCEPTION:
      return 'Failed';
    case data?.status === fastTrackStatus.CANCELLED:
      return 'Canceled';
    case data?.status === fastTrackStatus.INVALIDATED:
      return 'Invalidated';
    default:
      message = '';
  }

  return message;
};
